import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createI18n } from 'vue-i18n'
import messages from './i18n'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@fontsource/material-icons'
import '@fontsource/material-icons-outlined'
import './styles/tokens.css'
import './styles/material-icons.css'
import './styles/base.css'
import './styles/workspace.css'
import './styles/creation-form.css'
import './styles/partner.css'

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages,
  flatJson: false,
  allowComposition: true
})

const app = createApp(App)
app.use(router)
app.use(i18n)
app.use(ElementPlus)
app.mount('#app')
